import type { CSSProperties, HTMLAttributes, ReactNode } from 'react'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode
}

const cardStyle: CSSProperties = {
  background: '#fff',
  border: '1px solid #e5e7eb',
  borderRadius: 8,
  padding: '1.25rem',
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
}

export function Card({ style, ...rest }: CardProps) {
  return <div {...rest} style={{ ...cardStyle, ...style }} />
}
